<template>
    <div>
        <v-container grid-list-xs fluid v-if="toggle">
            <v-card>
                <dynamic-toolbar title="Gruping Rates FlatRate - FBH" :loading="loading.lists" color="indigo" icon="mdi-note-search"
                    theme="dark">
                    <template #buttons>
                    <v-btn color="blue" depressed @click="openNew" small dark>
                        <v-icon left>mdi-plus-circle</v-icon>
                        New
                    </v-btn>
                </template>
                </dynamic-toolbar>
                <v-container grid-list-xs fluid>
                    <v-data-table
                        :headers="headers"
                        :items="flats"
                        dense
                    >
                        <template v-slot:item.Truck="{item}">
                                <v-combobox v-model="item.Truck" placeholder="Select truck" :items="trucks" dense hide-details
                                @change="updateAmount(item)" required :item-text="'Truck'" :item-value="'TruckID'" auto-select-first></v-combobox>
                        </template> 

                        <template v-slot:item.Only="{item}">
                            <v-switch
                            dense
                            hide-details
                            v-model="item.Only"
                            @change="updateAmount(item)"
                            ></v-switch>
                        </template>
                        <template v-slot:item.Active="{item}">
                            <v-switch
                            dense
                            hide-details
                            v-model="item.Active"
                            @change="updateAmount(item)"
                            ></v-switch>
                        </template>
                        <template v-slot:item.Amount="{item}">
                            <v-text-field
                            dense
                            hide-details
                            v-model="item.Amount"
                            @change="updateAmount(item)"
                            ></v-text-field>
                        </template>
                        
                        <template v-slot:item.LiterPerRate="{item}">
                            <v-switch
                            dense
                            hide-details
                            color="teal"
                            v-model="item.LiterPerRate"
                            @change="updateAmount(item)"
                            ></v-switch>
                        </template>
                        <template v-slot:item.Action="{item,idx}">
                            <v-btn color="secondary" @click="showFBHolds(item)" icon><v-icon>mdi-page-next</v-icon></v-btn>
                            <v-btn color="red" @click="dltFlat(item.MainFlatRateId, idx)" icon><v-icon>mdi-delete</v-icon></v-btn>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>
            <addFlat v-if="openAddFR" :openAddFR="openAddFR" @close="closeNew"></addFlat>
            <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
        </v-container>
        <FBHolds v-else="toggle" :Trip="trip" :MainFlat="mainFlat" @close="toggle = !toggle; "></FBHolds>
    </div>
</template>
<script>
function logErr(error) {
    console.log(error);
}
import axios from 'axios';
import DateRangeMenu from '@/components/Global/Utils/DateRangeMenu.vue';
import DynamicToolbar from '../../components/Global/Utils/DynamicToolbar.vue';
import addFlat from '@/components/Catalogs/GroupingRates/AddNewFlat.vue';
import FBHolds from '@/components/Catalogs/GroupingRates/GroupingRate.vue';
import ConfirmDialogue from '@/components/Modals/ConfirmDialogue.vue';

// import { method } from 'lodash';
export default {
    components: {
        DynamicToolbar,
        DateRangeMenu,
        addFlat,
        ConfirmDialogue,
        FBHolds
    },
    data: () => ({
        loading: {
            lists: false,
            cost: false,
            dateRangeTotalCost: false,
            totalCostByType: false,
            totalCostByEquipment: false,
            totalCostByCategory: false,
            totalCostBySubcategory: false,
            report: false
        },
        headers:[
            {text: 'ID', value: 'MainFlatRateId'},
            {text: 'Trip', value: 'Trip'},
            {text: 'MainRate', value: 'MainRate'},
            {text: 'Truck', value: 'Truck'},
            {text: 'Only', value: 'Only'},
            {text: 'ByLiters', value: 'LiterPerRate'},
            {text: 'Amount', value: 'Amount'},
            {text: 'Active', value: 'Active'},
            {text: 'Action', value: 'Action'},
            
        ],
        trucks:[],
        flats:[],
        trip:null,
        mainFlat: null,
        openAddFR:false,
        toggle:true,
    }),
    methods: {
        updateAmount: function (itm) {
            var parms = {
                Only : itm.Only,
                Active: itm.Active,
                LiterPerRate: itm.LiterPerRate,
                Amount: itm.Amount,
                Truck: itm.Truck === null ? null : itm.Truck.TruckID,
            }
            axios
                .put('main-flat-rate/' + itm.MainFlatRateId,parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    // this.flats = response.data;
                })
                .catch(error => {
                    this.logErr(error);
                })
                .finally(() => {
                    this.loading.lists = false;
                    this.show = true;
                });
        },
        getMains() {
            this.loading.lists = true;
            axios
                .get('main-flat-rate', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.flats = response.data;
                    console.log(this.flats);
                    await this.flats.forEach(async x => {
                        const idx = await this.trucks.findIndex(y => {
                            return  x.Truck == y.TruckID;
                        });
                        console.log(idx);
                        x.Truck = this.trucks[idx];
                    });
                })
                .catch(error => {
                    this.logErr(error);
                })
                .finally(() => {
                    this.loading.lists = false;
                    this.show = true;
                });
        },
        openNew: function(){
            this.openAddFR = true;
        },
        closeNew: function(){
            this.openAddFR = false;
            this.getMains();
        },
        async dltFlat(id,idx) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to delete this FlatRate, if you delete it you will also lose your added BackHaul and FrontHauls.',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.deleteFlat(id,idx);
            }
        },
        deleteFlat: function (id,idx) {
            axios
                .delete('main-flat-rate/' + id, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    console.log(response.data);
                    this.flats.splice(idx,1);
                })
                .catch(error => {
                    this.logErr(error);
                })
                .finally(() => {
                    this.loading.lists = false;
                    this.show = true;
                });
        },
        showFBHolds: function (itm){
            this.mainFlat = itm.MainFlatRateId;
            this.trip = itm.Trip;
            this.toggle = false;
        },
        
        loadTrucks: function () {
            axios
                .get('truck/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.trucks = response.data;
                    this.getMains();
                    console.log(this.trucks);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
    },

    mounted() {
        this.loadTrucks();
    },
}

</script>
